(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('modals', ["confirmModal", "alertModal", "paramsModal", "tableModal", "treeModal", "widgetModal", "conditionsEditorModal", "smartSearchRuleModal", "keyValueGraphModal", "htmlXmlModal", "pdfViewerModal", "versionInfoModal", function (confirmModal, alertModal, paramsModal, tableModal, treeModal, widgetModal, conditionsEditorModal, smartSearchRuleModal, keyValueGraphModal, htmlXmlModal, pdfViewerModal, versionInfoModal) {
        return {
            confirm: confirmModal.show,
            alert: alertModal.show,
            params: paramsModal.show,
            table: tableModal.show,
            tree: treeModal.show,
            widget: widgetModal.show,
            conditionsEditor: conditionsEditorModal.show,
            smartSearchRule: smartSearchRuleModal.show,
            keyValueGraph: keyValueGraphModal.show,
            htmlXmlViewer: htmlXmlModal.show,
            pdfViewer: pdfViewerModal.show,
            versionInfo: versionInfoModal.show
        };
    }]);
}());